export interface Service {
  id: string;
  name: string;
  host: string;
  port: number;
  protocol: string;
  created_at: string;
  updated_at: string;
}

export interface Region {
  id: string;
  name: string;
  geo: string;
  tags?: string[];
  targets: RegionTarget[];
  health_status: 'healthy' | 'unhealthy';
  node_status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
}

export interface RegionTarget {
  id: string;
  target: string;
  weight: number;
  health_status: 'healthy' | 'unhealthy';
  node_status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
}

export interface Route {
  id: string;
  name: string;
  service: { id: string };
  paths: string[];
  hosts: string[];
  methods: string[];
  plugins: string[];
  created_at: string;
  updated_at: string;
}

export interface Plugin {
  id: string;
  name: string;
  service: { id: string };
  route?: { id: string };
  enabled: boolean;
  category: 'auth' | 'rate-limiting' | 'security' | 'transformation';
  created_at: string;
  updated_at: string;
}

export interface OperationLog {
  id: string;
  operation_type: string;
  description: string;
  operator: string;
  operation_time: string;
  api_request?: {
    method: string;
    url: string;
    headers: Record<string, string>;
    body?: any;
  };
  api_response?: {
    status: number;
    body: any;
  };
}

export const mockServices: Service[] = [
  {
    id: "svc-001",
    name: "user-service",
    host: "user-api.internal",
    port: 8080,
    protocol: "http",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  }
];

export const mockRegions: Region[] = [
  {
    id: "huzhou1",
    name: "huzhou1",
    tags: ["预生产区域"],
    geo: "Asia",
    targets: [
      {
        id: "cn-sh-target-001",
        target: "common-gateway.sh3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:14:02",
        updated_at: "2024-12-23 13:14:02"
      },
      {
        id: "cn-sh-target-002",
        target: "common-gateway.bj2.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-09-06 16:06:58",
        updated_at: "2024-09-06 16:06:58"
      },
      {
        id: "cn-sh-target-003",
        target: "common-gateway.gz3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-09-05 21:50:17",
        updated_at: "2024-09-05 21:50:17"
      }
    ],
    health_status: "healthy",
    node_status: "active",
    created_at: "2024-09-05 21:50:17",
    updated_at: "2024-12-23 13:14:02"
  },
  {
    id: "ap-singapore",
    name: "ap-singapore",
    geo: "AsiaPacific",
    targets: [
      {
        id: "ap-sg-target-001",
        target: "common-gateway.hk3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:35:52",
        updated_at: "2024-12-23 13:35:53"
      },
      {
        id: "ap-sg-target-002",
        target: "common-gateway.ty3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:35:35",
        updated_at: "2024-12-23 13:35:36"
      },
      {
        id: "ap-sg-target-003",
        target: "common-gateway.sg3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:35:14",
        updated_at: "2024-12-23 13:35:15"
      }
    ],
    health_status: "healthy",
    node_status: "active",
    created_at: "2024-12-23 13:35:14",
    updated_at: "2024-12-23 13:35:53"
  },
  {
    id: "eu-london",
    name: "eu-london",
    geo: "Europe",
    targets: [
      {
        id: "eu-lon-target-001",
        target: "common-gateway.pa3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 14:40:36",
        updated_at: "2024-12-23 14:40:36"
      },
      {
        id: "eu-lon-target-002",
        target: "common-gateway.fr3.agoralab.co:443",
        weight: 100,
        health_status: "unhealthy",
        node_status: "active",
        created_at: "2024-12-23 12:18:20",
        updated_at: "2024-12-23 12:18:21"
      },
      {
        id: "eu-lon-target-003",
        target: "common-gateway.nd3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 12:16:12",
        updated_at: "2024-12-23 12:16:13"
      }
    ],
    health_status: "healthy",
    node_status: "active",
    created_at: "2024-12-23 12:16:12",
    updated_at: "2024-12-23 14:40:36"
  },
  {
    id: "cn-shanghai",
    name: "cn-shanghai",
    geo: "Asia",
    targets: [
      {
        id: "cn-sh-target-001",
        target: "common-gateway.sh3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:14:02",
        updated_at: "2024-12-23 13:14:02"
      },
      {
        id: "cn-sh-target-002",
        target: "common-gateway.bj2.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-09-06 16:06:58",
        updated_at: "2024-09-06 16:06:58"
      },
      {
        id: "cn-sh-target-003",
        target: "common-gateway.gz3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-09-05 21:50:17",
        updated_at: "2024-09-05 21:50:17"
      }
    ],
    health_status: "healthy",
    node_status: "active",
    created_at: "2024-09-05 21:50:17",
    updated_at: "2024-12-23 13:14:02"
  },
  {
    id: "na-oregon",
    name: "na-oregon",
    geo: "NorthAmerica",
    targets: [
      {
        id: "na-or-target-001",
        target: "common-gateway.dc3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-12-23 13:40:57",
        updated_at: "2024-12-23 13:40:58"
      },
      {
        id: "na-or-target-002",
        target: "common-gateway.la3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-10-10 11:21:03",
        updated_at: "2024-10-10 11:21:03"
      },
      {
        id: "na-or-target-003",
        target: "common-gateway.da3.agoralab.co:443",
        weight: 100,
        health_status: "healthy",
        node_status: "active",
        created_at: "2024-10-10 11:20:50",
        updated_at: "2024-10-10 11:20:50"
      }
    ],
    health_status: "healthy",
    node_status: "active",
    created_at: "2024-10-10 11:20:50",
    updated_at: "2024-12-23 13:40:58"
  }
];

export const mockRoutes: Route[] = [
  {
    id: "stt-global.route.6ad44cd7",
    name: "stt-global.route.6ad44cd7",
    service: { id: "svc-001" },
    hosts: ["api.agora.io", "api.sd-rtn.com"],
    paths: ["/api/speech-to-text/v1/projects/(?-appid>\\w+)/join"],
    plugins: ["basic-auth", "hmac-auth","ip-restriction"],
    methods: ["POST"],
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "stt-global.route.b57e8365",
    name: "stt-global.route.b57e8365",
    service: { id: "svc-001" },
    hosts: ["api.agora.io", "api.sd-rtn.com"],
    paths: ["/api/speech-to-text/v1/projects/(?-appid>\\w+)/agents/(?-agentId>\\w+)"],
    plugins: [],
    methods: ["GET"],
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "stt-global.route.95ed52dc",
    name: "stt-global.route.95ed52dc",
    service: { id: "svc-001" },
    hosts: ["api.agora.io", "api.sd-rtn.com"],
    paths: ["/api/speech-to-text/v1/projects/(?-appid>\\w+)/agents/(?-agentId>\\w+)/update"],
    plugins: [],
    methods: ["POST"],
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "stt-global.route.99c1501c",
    name: "stt-global.route.99c1501c",
    service: { id: "svc-001" },
    hosts: ["api.agora.io", "api.sd-rtn.com"],
    paths: ["/api/speech-to-text/v1/projects/(?-appid>\\w+)/agents/(?-agentId>\\w+)/leave"],
    plugins: [],
    methods: ["POST"],
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  }
];

export const mockPlugins: Plugin[] = [
  // Authentication Plugins
  {
    id: "plugin-001",
    name: "jwt",
    service: { id: "svc-001" },
    enabled: false,
    category: "auth",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-002",
    name: "basic-auth",
    service: { id: "svc-001" },
    enabled: true,
    category: "auth",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-003",
    name: "hmac-auth",
    service: { id: "svc-001" },
    enabled: false,
    category: "auth",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-004",
    name: "wolf-rbac",
    service: { id: "svc-001" },
    enabled: false,
    category: "auth",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  // Rate Limiting Plugins
  {
    id: "plugin-005",
    name: "percentage-rate-limit",
    service: { id: "svc-001" },
    enabled: false,
    category: "rate-limiting",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-006",
    name: "rate-limiting",
    service: { id: "svc-001" },
    enabled: false,
    category: "rate-limiting",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  // Security Plugins
  {
    id: "plugin-007",
    name: "ip-restriction",
    service: { id: "svc-001" },
    enabled: true,
    category: "security",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-008",
    name: "cors",
    service: { id: "svc-001" },
    enabled: false,
    category: "security",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  // Data Transformation Plugins
  {
    id: "plugin-009",
    name: "request-transformer",
    service: { id: "svc-001" },
    enabled: false,
    category: "transformation",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-010",
    name: "response-transformer",
    service: { id: "svc-001" },
    enabled: false,
    category: "transformation",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-011",
    name: "jsonp",
    service: { id: "svc-001" },
    enabled: false,
    category: "transformation",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  },
  {
    id: "plugin-012",
    name: "path-rewrite",
    service: { id: "svc-001" },
    enabled: false,
    category: "transformation",
    created_at: "2024-03-25T01:00:00Z",
    updated_at: "2024-03-25T01:00:00Z"
  }
];

export const mockOperationLogs: OperationLog[] = [
  {
    id: "op-001",
    operation_type: "UPDATE_ROUTE",
    description: "修改路由配置",
    operator: "admin",
    operation_time: "2024-03-25T02:30:00Z",
    api_request: {
      method: "PUT",
      url: "/api/v1/routes/stt-global.route.6ad44cd7",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer xxxxxx"
      },
      body: {
        hosts: ["api.agora.io", "api.sd-rtn.com"],
        paths: ["/api/speech-to-text/v1/projects/(?-appid>\\w+)/join"],
        methods: ["POST"]
      }
    },
    api_response: {
      status: 200,
      body: {
        message: "Route updated successfully"
      }
    }
  },
  {
    id: "op-002",
    operation_type: "UPDATE_UPSTREAM",
    description: "更新上游服务地址",
    operator: "admin",
    operation_time: "2024-03-25T01:00:00Z",
    api_request: {
      method: "PUT",
      url: "/api/v1/services/svc-001/upstream",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer xxxxxx"
      },
      body: {
        host: "user-api.internal",
        port: 8080
      }
    },
    api_response: {
      status: 200,
      body: {
        message: "Upstream configuration updated successfully"
      }
    }
  }
]; 